module.exports = __webpack_public_path__ + "static/media/piggy-bank.91d563ad.svg";